export const TITLE = 'Type of organisation';
export const DB_PREFIX = 'type';
